/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Facility information for the receiver of the fax
 * @export
 * @interface FacilityCustomTagFacility
 */
export interface FacilityCustomTagFacility {
    /**
     * 
     * @type {string}
     * @memberof FacilityCustomTagFacility
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FacilityCustomTagFacility
     */
    name: string;
}

/**
 * Check if a given object implements the FacilityCustomTagFacility interface.
 */
export function instanceOfFacilityCustomTagFacility(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function FacilityCustomTagFacilityFromJSON(json: any): FacilityCustomTagFacility {
    return FacilityCustomTagFacilityFromJSONTyped(json, false);
}

export function FacilityCustomTagFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityCustomTagFacility {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function FacilityCustomTagFacilityToJSON(value?: FacilityCustomTagFacility | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

